import { Notification as customNotification } from '../../components/ui/custom-notification';
import get from 'lodash/get';
import axiosConfig from './axiosConfig';



export const SaveProjectSetup = async (projectData,isEdit = false) => {

    try {
      let res;

        const url = `/pipeDetails/createUpdateBulkPipeDetails`;
      
        res = await axiosConfig.post(url, projectData);
      
      if (res.status === 403) {
        customNotification.error('Unauthorized', 'You do not have permission to access this resource.');
        return null;
      }
      if (res.status === 200) {
        if(!isEdit)
        customNotification.success(
          'Setup Saved Successfully',
          'The project setup has been saved successfully.'
        );
        return res.data;
      }
      if (res.status === 502) {
        customNotification.error('Service temporarily unavailable', 'The service is temporarily unavailable. Please try again later.');
        return null;
      }
      return null;
    } catch (error) {
      customNotification.error('Failed to add project setup', error.error);
      return null;
    }
  }


  export const SaveProjectSetupJobNumbers = async (jobNumbersData) => {

    try {
      let res;

        const url = `/pipeDetails/updateJobNumber`;
      
        res = await axiosConfig.put(url, jobNumbersData);
      
      if (res.status === 403) {
        customNotification.error('Unauthorized', 'You do not have permission to access this resource.');
        return null;
      }
      if (res.status === 200) {
        // customNotification.success(
        //   'Job Numbers Saved Successfully',
        //   'The job numbers have been saved successfully.'
        // );
        return res.data;
      }
      if (res.status === 502) {
       // customNotification.error('Service temporarily unavailable', 'The service is temporarily unavailable. Please try again later.');
        return null;
      }
      return null;
    } catch (error) {
    //  customNotification.error('Failed to add project setup', error.error);
      return null;
    }
  }

  export const AddManufacturingCategory = async (data) => {

    try {
      let url = '/manufacturer/createUpdateManufacturer';
     
      const res = await axiosConfig.post(url, data);
  
      customNotification.destroy();
      if (res.status === 200) {
        const responseData = get(res, ['data', 'data'], {});
  
        customNotification.success('Added Successfully.', 'The manufacturer was added successfully.');
  
        return responseData
  
      }
  
      else {
  
        customNotification.error('Failed to add  manufacturer', 'Please try again');
        return null
  
      }
  
  
    } catch (error) {
  
      if(error?.data?.includes('Validation error')){
        customNotification.warning(`${data.manufacturer_name} already exists`, 'Please enter a different manufacturer name');
      }
      else{
        customNotification.error('Failed to add  manufacturer', error.data);
      }
      return null
  
    }
  }
  
  export const getListManufacturingCategory = async () => {
    try {
      let url;
    
        url = `/manufacturer/getAllManufacturers`;
  
  
      const res = await axiosConfig.get(url);
      if (res.status === 403) {
        customNotification.error('Unauthorized', 'You do not have permission to access this resource.');
        return null;
      } if (res.status === 200) {
        const data = get(res, ['data', 'data'], {});
        return data?.data || [];
      }
      return [];
    } catch (error) {
      customNotification.error('Failed to fetch manufacturing category', error.error);
      return [];
    }
  };
  export const GetAllPipeDetails = async (project_id) => {
    try {
    
     const   url = `/pipeDetails/getAllPipeDetails?project_id=${project_id}`;
  
      const res = await axiosConfig.get(url);
     
      if (res.status === 403) {
        customNotification.error('Unauthorized', 'You do not have permission to access this resource.');
        return null;
      } if (res.status === 200) {
        const data = get(res, ['data', 'data'], {});
       
        return data || {};
      }
      return [];
    } catch (error) {
      customNotification.error('Failed to fetch pipe details', error.error);
      return [];
    }
  };

  export const deleteSetupData = async (payload) => {
    try {
     
      const res = await axiosConfig.post(`/pipeDetails/bulkDeletePipeDetails`,payload);
  
      if (res.status === 403) {
        customNotification.error('Unauthorized', 'You do not have permission to access this resource.');
        return null;
      }
      if (res.status === 200) {
     
        return res.data;
      }
      return null;
    } catch (error) {
      customNotification.error( 'Failed to delete documents', error.data);
      return null;
    }
  }